// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"sE-z","smallCardRow":"tE-z","largeCardRow":"uE-z","productSearchRow":"vE-z","curatedRow":"wE-z"};